'use client';
import { createTheme, responsiveFontSizes } from '@mui/material';
import { ButtonOverrides } from '../../components/button/button.overrides.js';
import breakpoints from '../../styles/breakpoints.module.scss.js';
import palette from '../../styles/palette.module.scss.js';
import spacing from '../../styles/spacing.module.scss.js';
import typography from '../../styles/typography.module.scss.js';

const FALLBACK_FONT_FAMILY = 'sans-serif';
const LIGHT_THEME_KEY = 'light';
const lightTheme = (() => {
    const baseTheme = createTheme({
        breakpoints: {
            values: Object.keys(breakpoints)
                .filter((key) => key !== '__checksum')
                .reduce((acc, breakpoint) => {
                acc[breakpoint] = Number(breakpoints[breakpoint].replace('px', ''));
                return acc;
            }, {}),
        },
        components: {
            MuiButton: ButtonOverrides,
        },
        palette: {
            action: {
                activatedOpacity: Number(palette.actionActivatedOpacity),
                active: palette.actionActive,
                disabled: palette.actionDisabled,
                disabledBackground: palette.actionDisabledBackground,
                disabledOpacity: Number(palette.actionDisabledOpacity),
                focus: palette.actionFocus,
                focusOpacity: Number(palette.actionFocusOpacity),
                hover: palette.actionHover,
                hoverOpacity: Number(palette.actionHoverOpacity),
                selected: palette.actionSelected,
                selectedOpacity: Number(palette.actionSelectedOpacity),
            },
            background: {
                default: palette.backgroundDefault,
                paper: palette.backgroundPaper,
            },
            common: {
                black: palette.commonBlack,
                white: palette.commonWhite,
            },
            contrastThreshold: Number(palette.contrastThreshold),
            divider: palette.divider,
            error: {
                background: palette.errorBackground,
                contrastText: palette.errorContrastText,
                dark: palette.errorDark,
                light: palette.errorLight,
                main: palette.errorMain,
                onBackground: palette.errorOnBackground,
            },
            grey: {
                '50': palette.grey_50,
                // eslint-disable-next-line sort-keys
                '100': palette.grey_100,
                '200': palette.grey_200,
                '300': palette.grey_300,
                '400': palette.grey_400,
                '500': palette.grey_500,
                '600': palette.grey_600,
                '700': palette.grey_700,
                '800': palette.grey_800,
                '900': palette.grey_900,
                'A100': palette.greyA100,
                'A200': palette.greyA200,
                'A400': palette.greyA400,
                'A700': palette.greyA700,
            },
            info: {
                contrastText: palette.infoContrastText,
                dark: palette.infoDark,
                light: palette.infoLight,
                main: palette.infoMain,
            },
            mode: 'light',
            primary: {
                contrastText: palette.primaryContrastText,
                dark: palette.primaryDark,
                hover: palette.primaryHover,
                light: palette.primaryLight,
                main: palette.primaryMain,
                selected: palette.primarySelected,
            },
            secondary: {
                contrastText: palette.secondaryContrastText,
                dark: palette.secondaryDark,
                light: palette.secondaryLight,
                main: palette.secondaryMain,
            },
            success: {
                contrastText: palette.successContrastText,
                dark: palette.successDark,
                light: palette.successLight,
                main: palette.successMain,
                onBackground: palette.successOnBackground,
            },
            text: {
                disabled: palette.textDisabled,
                primary: palette.textPrimary,
                secondary: palette.textSecondary,
            },
            tonalOffset: Number(palette.tonalOffset),
            warning: {
                background: palette.warningAlertBackground,
                contrastText: palette.warningContrastText,
                dark: palette.warningDark,
                light: palette.warningLight,
                main: palette.warningMain,
                onBackground: palette.warningOnBackground,
            },
        },
        spacing: Number(spacing.spacing.replace('px', '')),
        typography: {
            fontFamily: ['Proxima Nova Alt Rg', FALLBACK_FONT_FAMILY].join(','),
            fontWeightBold: Number(typography.fontWeightBold),
            fontWeightLight: Number(typography.fontWeightLight),
            fontWeightMedium: Number(typography.fontWeightMedium),
            fontWeightRegular: Number(typography.fontWeightRegular),
        },
    });
    return responsiveFontSizes(baseTheme);
})();

export { LIGHT_THEME_KEY, lightTheme };
